import { useMutation } from "@apollo/client";

import { gql } from "~/__generated__";

const PLANNER_VISIT_RECALCULATE_DAYS = gql(`
mutation PlannerVisitRecalculateDays {
    plannerVisitRecalculateDays
}
`);

export default function usePlannerVisitRecalculateDays() {
    const [plannerVisitRecalculateDays, { loading, error }] = useMutation(PLANNER_VISIT_RECALCULATE_DAYS);

    return {
        plannerVisitRecalculateDays,
        loading,
        error,
    };
}
